const POLICY_SEARCH_ENVELOPE_KINDS = {
  V1: 'policy_api_v1_single',
  V2: 'policy_api_v2_single',
} as const;

export default POLICY_SEARCH_ENVELOPE_KINDS;
